// `extension-alert-client-contacts-filter-tooltip.tpl.html` — the contacts screen's "Filters"
// menu.
//
// ⚠️ IT IS A FLAT LIST, NOT THE CANDIDATE MENU. The candidate tooltip's "Group" header and its
// two collapsible sections are COMMENTED OUT in this template, and the CV-date group does not
// exist here at all — what is left is one row per shown-option, with its own wrapper class and
// its own selected class. Reusing `CandidateFiltersTooltip` would draw two collapsibles and a
// date filter this screen has never had.
import { type ReactElement } from 'react'
import type { ClientContactShowFilterOption } from './clientContactFilters.ts'

export interface ClientContactFiltersTooltipProps {
  shownOption: ClientContactShowFilterOption
  shownOptions: readonly ClientContactShowFilterOption[]
  onSelectShown?: (option: ClientContactShowFilterOption) => void
}

export function ClientContactFiltersTooltip({
  shownOption,
  shownOptions,
  onSelectShown,
}: ClientContactFiltersTooltipProps): ReactElement {
  return (
    <div className="extension-candidates-filters-tooltip-container">
      {shownOptions.map((option) => (
        <div className="client-contact-extension-candidates-filters-tooltip-item-wrap" key={option.name}>
          {/* The comparison upstream writes is `ctrl.currClientContactShownOption === option` —
              an identity check, which holds because the current option is taken FROM this
              array. Compared by name here for the same reason the candidate menu is: the
              current option is rebuilt from the alert rather than looked up. */}
          <span
            className={`cursor-pointer extension-candidates-filters-tooltip-item${
              option.name === shownOption.name
                ? ' client-contact-extension-candidates-filters-tooltip-item-selected'
                : ''
            }`}
            role="button"
            tabIndex={0}
            onClick={() => {
              onSelectShown?.(option)
            }}
            onKeyDown={(event) => {
              if (event.key !== 'Enter' && event.key !== ' ') return
              event.preventDefault()
              onSelectShown?.(option)
            }}
          >
            <i className={option.cssClass} />
            &nbsp;&nbsp;
            {option.name}
          </span>
        </div>
      ))}
    </div>
  )
}
